// Section 7: spoilage per season (rate from the pipeline: granary, cistern, lining), stock over
// capacity spoils at 3x, and stock beyond the hard cap (D-10) is lost at once. Seed is held out
// of food but shares food's capacity and spoilage rate.
import { RESOURCES } from '../../core/constants';
import { round6 } from '../../core/math';
import type { PhaseContext, Resource } from '../../core/types';
import { addStock } from '../shared/stocks';
import { num } from '../shared/value';

function spoil(ctx: PhaseContext, r: Resource): void {
  const stock = ctx.draft.stocks[r];
  const seed = r === 'food' ? ctx.draft.seedReserved : 0;
  const total = stock.amount + seed;
  if (total <= 0) return;
  const rate = Math.max(0, num(ctx, { kind: 'spoilage', resource: r }));
  const over = Math.max(0, total - stock.capacity);
  const overRate = Math.min(1, rate * ctx.cfg.resources.overCapacitySpoilageMul);
  let lost = (total - over) * rate + over * overRate;
  const hardCap = stock.capacity * ctx.cfg.resources.hardCapFactor;
  if (total - lost > hardCap) lost = total - hardCap;
  if (lost <= 0) return;
  const seedShare = seed > 0 ? Math.min(seed, lost * (seed / total)) : 0;
  if (seedShare > 0) {
    ctx.draft.seedReserved = Math.max(0, seed - seedShare);
    ctx.report.add({
      kind: 'spoilage',
      resource: 'seed',
      amount: round6(seedShare),
      overCapacity: 0,
    });
  }
  const moved = -addStock(ctx, r, -(lost - seedShare), 'spoilage');
  if (moved > 1e-6)
    ctx.report.add({
      kind: 'spoilage',
      resource: r,
      amount: round6(moved),
      overCapacity: round6(over),
    });
}

export function spoilStocks(ctx: PhaseContext): void {
  for (const r of RESOURCES) spoil(ctx, r);
}
